module.exports = __webpack_public_path__ + "static/media/moons_advanced-375.c6e39543.webp";